const throttle = [{
  value: 0,
  text: 'Full'
}, {
  value: 5000,
  text: 'Slow'
}, {
  value: 10000,
  text: 'Dead Slow'
}]

export default throttle



// WEBPACK FOOTER //
// ./src/helpers/device-emulator-throttles.js